import React, { FunctionComponent } from 'react'
import style from '../equipmentSearchFilter.css'

export type Props = {
    value: string
    onChange: (value: string) => void
    placeholder: string
}

const PageSearchInput: FunctionComponent<Props> = (props) => {
    const { value, onChange, placeholder } = props

    const handleClear = () => {
        onChange('')
    }

    return (
        <div className={style.inputContainer}>
            <input
                id="page-search-input"
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className={style.pageInput}
                data-testid="page-search-input"
            />
            {value && (
                <button
                    type="button"
                    onClick={handleClear}
                    className={style.clearButton}
                    aria-label="Clear input"
                    data-testid="page-search-clear-button"
                >
                    <span className={style.clearIcon}>×</span>
                </button>
            )}
        </div>
    )
}

export default PageSearchInput
